import { useRouteMatch } from 'react-router-dom';
import { useAuthContext } from '../../components/app/components/auth/auth';
import { Routing } from '../../global';

export function useIsAdminOnBuyOrderEditForm() {
  const auth = useAuthContext();
  const match = useRouteMatch();

  const isOnCreatePath = match.path === Routing.BuyProcess;

  return !isOnCreatePath && auth.isAuthenticated;
}
